import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import { Link } from 'react-router-dom';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import './projectCard.css';

const styles = theme=> ({


  card: {
    padding:'auto',
    width:'auto',
    margin:'auto',
    webkitBoxShadow: "none !important",
    mozBoxShadow: "none !important",
    boxShadow: "none !important"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
    borderRadius: 0
  },
  title: {
    marginBottom: 16,
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  media: {
    height: '400',
     width: '400'

  },
  content:{
      padding:'0px'
  }
});

function ProjectCard(props) {
  const { classes } = props;
  const slug = encodeURIComponent(props.project.slug);
  const cardImage = props.project.thumbnailUrl || (props.project.gallery && props.project.gallery[0]) || '/content/Home/1.jpg';


  return (
    <div className='project-card'>
      <Link to={`/projects/${slug}`}>
      <Card className={classes.card} align="center">
      <CardActionArea>
        
        <CardContent className='card-content'>
        <img className='cardImage' src={cardImage} alt={props.project.title}/>
        <div className="title-name">
          <div className="project">{props.project.name}</div>
          {/* <div className="location">{props.project.location}</div> */}
        </div>
        </CardContent>
        </CardActionArea>
      </Card>
      </Link>
    </div>
  );
}

ProjectCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProjectCard);
